import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'loyal-react'

const IconItem = props => {
  var classNameIcon = ''

  switch (props.vendorId) {
    case 71:
      classNameIcon = 'icon_phone'
      break
    default:
      classNameIcon = ''
      break
  }

  return (
    <div className='tracking-item-icon pos-relative col-auto order-1'>
      <Icon iconName={`${classNameIcon}`} />
    </div>
  )
}

IconItem.propTypes = {
  vendorId: PropTypes.number
}

export default IconItem



// WEBPACK FOOTER //
// ./src/Participant/Scheduling/ScheduledOrderList/ScheduleOrderItem/IconItem.js